var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-5 mb-2 mt-2",attrs:{"color":"indigo","dark":""},on:{"click":function($event){return _vm.makeShootingBookExcel()}}},[_vm._v(" Excel "),_c('v-icon',{attrs:{"right":""}},[_vm._v("mdi-microsoft-excel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }